<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("quality.nav.title")}} - {{$t("quality.buy.breadcrumb")}}</div>
    <div class="container">
      <div class="img">
        <!--<img src="~assets/quality/buy.jpg"/>-->
        <Video :list="videoUrl"></Video>
      </div>
      <div class="des">
        <div class="icon">
          <img src="~assets/quality/buy_small.jpg"/>
        </div>
        <div class="text" v-html='$t("quality.buy.text")'></div>
      </div>
    </div>
  </div>
</template>

<script>
import Video from '../../../common/video/Index'
export default {
  name: 'JoinStatement',
  components: {Video},
  props: ['list'],
  data () {
    return {
      videoUrl: this.list[1]
    }
  },
  computed: {
  },
  mounted () {
    console.log(this.list[1])
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
    .container
      box-sizing border-box
      padding 0 23px
      letter-spacing 1px
      background url("~assets/quality/bg.jpg")
      bgRight()
      .img
        width 100%
        margin-bottom 50px
        flexCenter()
      .des
        flexBetween()
        .title
          cn()
          font-size 32px
          font-weight bold
          text-align center
          margin-bottom 40px
        .text
          margin-bottom 25px
          width 100%
          line-height 28px
</style>



// WEBPACK FOOTER //
// src/pages/quality/components/Buy.vue